import React, { useState } from 'react';
import LitStructuredText from './generic/LitStructuredText';
import LitImage from './images/LitImage';
import { Link } from 'gatsby';
const ModularCarouselSlide = ({
  index,
  image,
  heading,
  subheading,
  body,
  smallText,
  card,
  noReadMore,
}) => {
  const [readMore, setReadMore] = useState(false);

  return (
    <div className="modular-carousel-slide" key={index}>
      <div className="modular-carousel-slide-inner">
        <div className="carousel-slide-image">
          <LitImage image={image} alt="round image with person" />
        </div>
        <div className="carousel-slide-content">
          {heading ? (
            <LitStructuredText data={heading} basic />
          ) : (
            <h4>{card[0]?.jobTitle}</h4>
          )}
          {subheading ? (
            <LitStructuredText data={subheading} basic />
          ) : (
            <h5>{card[0]?.location}</h5>
          )}
          {card[0].remote && <p>Remote</p>}
          {
            <p className="carousel-slide-body">
              {body
                ? readMore
                  ? body
                  : `${body?.substring(0, 60)}...`
                : noReadMore && card[0]?.previewText}
            </p>
          }
          {!noReadMore && (
            <button
              onClick={() => {
                setReadMore(!readMore);
              }}
            >
              {readMore ? `...Read Less` : `...Read More`}
            </button>
          )}
          {card && (
            <Link
              to={`/careers/${card[0]?.slug}/`}
              className="carousel-card-link"
            >
              Find out more
            </Link>
          )}
          <div className="carousel-slide-small-text">
            <LitStructuredText data={smallText} basic />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModularCarouselSlide;
